export const newFeatureBanner = {
  "GotIt!": "Got it!",
  LearnMore: "Learn more",
} as const;
